var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.loadingCompleted)?_c('NotFound'):_c('SkeletonLoader',{attrs:{"pre-loading":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }